import { createIcon } from '../utils';

export const OpenEnvelopeIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.4531 2.19479L17.7265 6.27247C17.9482 6.41656 18.059 6.4886 18.1393 6.5847C18.2104 6.66976 18.2638 6.76816 18.2964 6.87412C18.3332 6.99382 18.3332 7.12601 18.3332 7.39039V13.5001C18.3332 14.9003 18.3332 15.6003 18.0607 16.1351C17.821 16.6055 17.4386 16.988 16.9681 17.2277C16.4334 17.5001 15.7333 17.5001 14.3332 17.5001H5.6665C4.26637 17.5001 3.56631 17.5001 3.03153 17.2277C2.56112 16.988 2.17867 16.6055 1.93899 16.1351C1.6665 15.6003 1.6665 14.9003 1.6665 13.5001V7.39039C1.6665 7.12601 1.6665 6.99382 1.70331 6.87412C1.7359 6.76816 1.78929 6.66976 1.86038 6.5847C1.94068 6.4886 2.05152 6.41656 2.27319 6.27247L8.54653 2.19479M11.4531 2.19479C10.9271 1.85287 10.6641 1.68191 10.3807 1.61539C10.1302 1.55659 9.86948 1.55659 9.61898 1.61539C9.33559 1.68191 9.07257 1.85287 8.54653 2.19479M11.4531 2.19479L17.4732 6.10785C17.7598 6.29414 17.9031 6.38729 17.9528 6.50541C17.9961 6.60864 17.9961 6.72498 17.9528 6.82821C17.9031 6.94634 17.7598 7.03948 17.4732 7.22578L11.4531 11.1388C10.9271 11.4808 10.6641 11.6517 10.3807 11.7182C10.1302 11.777 9.86948 11.777 9.61898 11.7182C9.33559 11.6517 9.07257 11.4808 8.54653 11.1388L2.52645 7.22577C2.23984 7.03948 2.09654 6.94634 2.04691 6.82821C2.00354 6.72498 2.00354 6.60864 2.04691 6.50541C2.09654 6.38729 2.23984 6.29414 2.52645 6.10785L8.54653 2.19479"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'OpenEnvelopeIcon' },
);
